import { createSvgIcon } from "@mui/material";

export const AnalyticsIcon = createSvgIcon(
  <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_12338_13466)">
      <path
        d="M4.16602 7.66699H6.66602V15.8337H4.16602V7.66699ZM8.83268 4.16699H11.166V15.8337H8.83268V4.16699ZM13.4993 10.8337H15.8327V15.8337H13.4993V10.8337Z"
        fill="#2962FF"
      />
    </g>
  </svg>,
  "Analytics"
);
